import { STANDARD_DISCLOSURE, type Partner } from "./types";

export const unidosUs: Partner = {
  slug: "unidos-us",
  name: "UnidosUS",
  fullName: "UnidosUS Homeownership Network (HOME)",
  path: "/partners/unidos-us",
  externalUrl: "https://unidosus.org/",
  externalLabel: "Find a UnidosUS affiliate",

  title: "UnidosUS Homeownership Network: Bilingual Housing Counseling (2026)",
  description:
    "The UnidosUS Homeownership Network is a group of HUD-approved community affiliates offering free bilingual housing counseling in English and Spanish. Who it fits, what a session covers, and how it pairs with stacking grants and down payment help.",
  h1: "UnidosUS: free bilingual housing counseling, in your language",

  cardHeadline: "Counseling in English or Spanish, free",
  cardBody:
    "The UnidosUS Homeownership Network is a set of HUD-approved community affiliates that counsel buyers in English and Spanish. Same free counseling any HUD agency offers — credit review, budget, a written plan, and the education certificate assistance programs ask for — delivered by people from the communities they serve.",
  cardPoints: ["Free HUD-approved counseling", "English and Spanish", "Education certificate", "Local affiliates"],

  barriers: ["language", "credit", "certificate"],
  hubSummary:
    "HUD-approved community affiliates offering free bilingual counseling and homebuyer education in English and Spanish.",

  fits: [
    "You'd rather have this conversation in Spanish, or bring a family member who would.",
    "You want free, unbiased counseling from a HUD-approved agency near you.",
    "An assistance program is asking for a homebuyer education certificate.",
    "You're new to the U.S. credit system or have thin credit history here.",
  ],
  doesNotFit: [
    "You need a lender decision this week — counseling is a runway, not a closing.",
    "You're looking for a direct cash grant from the organization itself.",
    "There is no participating affiliate in your area (check first, then use HUD's locator).",
  ],
  steps: [
    { title: "Find a participating affiliate", detail: "The network is made up of independent local nonprofits. Services and languages vary by office, so confirm before you book." },
    { title: "Book a counseling session", detail: "Free at HUD-approved agencies. Bring pay stubs, a list of debts, and any credit report you already have." },
    { title: "Get your credit and budget reviewed", detail: "The counselor names the specific accounts holding you back and builds a budget around a realistic payment." },
    { title: "Take the homebuyer education course", detail: "Most assistance programs require a certificate from an approved provider. Confirm your program accepts theirs." },
    { title: "Come back and stack", detail: "With a plan and a certificate in hand, run your Stack to see the grants and DPA available in your county." },
  ],
  compareLabel: "UnidosUS affiliate",
  compare: [
    { factor: "What you get", partner: "Bilingual counseling plus an education certificate", stack: "A list of grants and DPA you may qualify for" },
    { factor: "Cost", partner: "Free counseling; courses may carry a small disclosed fee", stack: "Free" },
    { factor: "Language", partner: "English and Spanish", stack: "English" },
    { factor: "Timeline", partner: "Weeks to months", stack: "Minutes" },
    { factor: "Provides money", partner: "No — some affiliates administer local DPA", stack: "Points you to program dollars" },
    { factor: "Best used", partner: "Before or alongside applying", stack: "Any time" },
  ],
  faqs: [
    { q: "Is UnidosUS counseling really free?", a: "One-on-one counseling at a HUD-approved agency is free. Some affiliates charge a modest, disclosed fee for the homebuyer education course, and that fee is often waived or sponsored — ask before you pay." },
    { q: "Do I have to speak Spanish?", a: "No. Affiliates serve English-speaking clients too. The point is that Spanish is available, not required." },
    { q: "Do I need to be a citizen or permanent resident?", a: "Counseling is open regardless of status. Mortgage eligibility itself is set by the loan program and lender, not by the counselor — a counselor can tell you which loan types your documentation supports." },
    { q: "Will the education certificate be accepted by my DPA program?", a: "Usually, but not always. Every assistance program keeps its own approved-provider list. Confirm with your specific program before paying for any course." },
    { q: "Does Home Approach get paid for this referral?", a: "No. We point members here because bilingual, HUD-approved counseling is genuinely hard to find and worth naming." },
  ],
  disclosure: STANDARD_DISCLOSURE("UnidosUS"),
};
